import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { getLoads } from "../../lib/api";
import { fmtDateTimeShort } from "../../lib/format";
import type { PanelLoad } from "../../lib/types";

export function LoadsTab() {
  const { t } = useAuth();
  const [loads, setLoads] = useState<PanelLoad[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    getLoads()
      .then(({ loads }) => setLoads(loads))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="p-4 space-y-3">
      <div className="text-sm font-semibold text-slate-800">{t("loads_title")}</div>
      {error && <div className="text-xs text-rose-600">{error}</div>}
      {loading && <div className="text-xs text-slate-500">…</div>}
      {!loading && loads.length === 0 && <div className="text-xs text-slate-500">{t("loads_empty")}</div>}
      {loads.length > 0 && (
        <ul className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100">
          {loads.map(l => (
            <li key={l.id} className="p-3 text-sm">
              <div className="flex items-center justify-between gap-2">
                <div className="font-medium text-slate-900">{l.month} · v{l.version}</div>
                <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${l.final ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>
                  {l.final ? t("loads_final") : t("loads_prelim")}
                </span>
              </div>
              <div className="text-[11px] text-slate-500 mt-0.5">
                {fmtDateTimeShort(l.published_at)} · {l.published_by ?? "—"} · {t("loads_employees", { n: l.employees_count })}
                {l.warnings.length > 0 && <span className="text-amber-700"> · {t("loads_warns", { n: l.warnings.length })}</span>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
